
/*/////////////////////////////////////////////////*/
import React from "react";

/* Design assets */
import './about.css';
import {MobileView, isMobile} from 'react-device-detect';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Info from '@material-ui/icons/Info';
import Close from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
    opacity: 0.9,    
  }),
  button: {
    //margin: theme.spacing.unit + 30,
    float: 'right',
    backgroundColor: '#3ab9c5',
    color:'blue'
    
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  
  info: {
    width: 400
  },

  infoMobile: {
    width: 320
  }


});
/* Design assets end */
/* ======================================================================================== */
class About extends React.Component {
  constructor (props) {
    super(props)

    this.state = {   
    }
  }

  main = () => {
    this.props.history.push('/');
  }
/* ======================================================================================== */
  
  render() {   
    const { classes } = this.props; 
  
    
    /* END */   

    return (  
      
      <div className="wrapper">
       
      <Paper className={classes.root}>      
      
        <Typography>
        <MobileView>
        <div className={classes.infoMobile}>
         
        <h4><Info className={classes.leftIcon} /> About MicroKeyVault.com 
        <Button className={classes.button} type="button" onClick={this.main}><Close /></Button>
        </h4>
        <h1>Disclaimer</h1>
        <p>Last updated: April 05, 2019</p>
        <p>The information contained on www.microkeyvault.com website and MicroKeyVault
          mobile app (the "Service") is for general information purposes only.</p>
        <p>MicroKeyVault assumes no responsibility for errors or omissions in the contents on the Service.</p>
        <p>In no event shall MicroKeyVault be liable for any special, direct, indirect, consequential, or 
          incidental damages or any damages whatsoever, whether in an action of contract, negligence or 
          other tort, arising out of or in connection with the use of the Service or the contents of the
          Service.</p>
        <p>MicroKeyVault reserves the right to make additions, deletions, or modification to the 
          contents on the Service at any time without prior notice. </p>
          </div>
        </MobileView>
        {!isMobile &&
        <div className={classes.info}>
         
        <h4><Info className={classes.leftIcon} /> About MicroKeyVault.com 
        <Button className={classes.button} type="button" onClick={this.main} color="secondary"><Close /></Button>
        </h4>
        <h1>Disclaimer</h1>
        <p>Last updated: April 05, 2019</p>
        <p>The information contained on www.microkeyvault.com website and MicroKeyVault
          mobile app (the "Service") is for general information purposes only.</p>
        <p>MicroKeyVault assumes no responsibility for errors or omissions in the contents on the Service.</p>
        <p>In no event shall MicroKeyVault be liable for any special, direct, indirect, consequential, or 
          incidental damages or any damages whatsoever, whether in an action of contract, negligence or 
          other tort, arising out of or in connection with the use of the Service or the contents of the
          Service.</p>
        <p>MicroKeyVault reserves the right to make additions, deletions, or modification to the 
          contents on the Service at any time without prior notice. </p>
          </div>
        }
        </Typography>
      
      </Paper>


      </div>      
     
    );
  }
}
export default withStyles(styles)(About);


// WEBPACK FOOTER //
// ./src/containers/About/about.js